import React from "react";
import loader from "../assets/gif/preloader.gif";
import langData from '../locales/langData.json';


const Preloader = ({language}) => {
     const text = langData[language].home;
    return (
        <center>
            <div className="preloader-container">
                <img src={loader} alt="Loading..." className="preloader-gif" />
                <h2 className="pre-text" dangerouslySetInnerHTML={{ __html: text.preloadertitle }}></h2>

                <p className="sec-p">
                    {text.preloaderdesc}
                </p>
            </div>
        </center>
    );
};

export default Preloader;
